export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-500 to-secondary-500 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-3">
              随时随地，畅快追漫
            </h2>
            <p className="text-background-50/80 text-sm leading-relaxed mb-6">
              妖精动漫网完美适配手机、平板和电脑，支持下拉式连续阅读。关注微信公众号或保存网页到桌面，打开就能看，无需下载安装。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
              <div className="flex items-center gap-2 px-5 py-2.5 bg-background-50/15 rounded-full border border-background-50/20 cursor-pointer transition-all duration-200 hover:bg-background-50/25">
                <i className="ri-smartphone-line text-background-50 text-lg"></i>
                <span className="text-background-50 text-sm font-medium whitespace-nowrap">手机网页版</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-2.5 bg-background-50/15 rounded-full border border-background-50/20 cursor-pointer transition-all duration-200 hover:bg-background-50/25">
                <i className="ri-wechat-line text-background-50 text-lg"></i>
                <span className="text-background-50 text-sm font-medium whitespace-nowrap">关注公众号</span>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden bg-background-50/15 border border-background-50/20 flex items-center justify-center">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20minimalist%20QR%20code%20design%20on%20warm%20cream%20background%2C%20subtle%20manga%20themed%20decorative%20corners%2C%20Japanese%20aesthetic%2C%20elegant%20simple%20style&width=448&height=448&seq=app-qr-placeholder&orientation=squarish"
                alt="妖精动漫网 移动端入口"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}